var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMultimediaFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1358",
    "data-name": "Grupo 1358",
    transform: "translate(-9.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1180",
    "data-name": "Grupo 1180",
    transform: "translate(10)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1179",
    "data-name": "Grupo 1179",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1178",
    "data-name": "Grupo 1178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1177",
    "data-name": "Grupo 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1176",
    "data-name": "Grupo 1176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1175",
    "data-name": "Grupo 1175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1174",
    "data-name": "Grupo 1174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_253",
    "data-name": "Rect\\xE1ngulo 253",
    width: 50,
    height: 47,
    transform: "translate(-0.151)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "IrYLnN.tif",
    transform: "translate(13.853 2.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1357",
    "data-name": "Grupo 1357",
    transform: "translate(5.862 7.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_625",
    "data-name": "Trazado 625",
    d: "M36.556,15.238c-.066.323-.122.648-.2.967a7.2,7.2,0,0,1-1.964,3.48q-6.552,6.551-13.105,13.1a1.058,1.058,0,0,1-1.242.293.978.978,0,0,1-.577-1.011,1.642,1.642,0,0,1,.228-.562,1.519,1.519,0,0,1,.274-.3Q26.4,24.779,32.835,18.35A5.539,5.539,0,0,0,34.4,15.572a5.153,5.153,0,0,0-4.191-6.085,5.084,5.084,0,0,0-4.548,1.5q-8.351,8.349-16.7,16.7a3.366,3.366,0,0,0,.966,5.546,3.551,3.551,0,0,0,3.879-.769c2.576-2.6,5.173-5.182,7.761-7.77,1.118-1.118,2.239-2.232,3.352-3.355a1.639,1.639,0,0,0-2.088-2.526,4.286,4.286,0,0,0-.344.316q-3.7,3.694-7.39,7.391a1.093,1.093,0,0,1-1.082.4,1.016,1.016,0,0,1-.594-1.6,1.933,1.933,0,0,1,.187-.209q3.793-3.795,7.59-7.588a3.688,3.688,0,0,1,5.422,5c-.1.117-.212.228-.323.339q-5.493,5.495-10.983,10.991a5.5,5.5,0,0,1-3.25,1.689,5.292,5.292,0,0,1-4.675-1.606,5.24,5.24,0,0,1-1.53-3.893A5.353,5.353,0,0,1,7.5,26.247Q15.866,17.87,24.243,9.5a6.978,6.978,0,0,1,5.836-2.1,7.135,7.135,0,0,1,6.284,5.527c.079.331.129.669.193,1Z",
    transform: "translate(-5.862 -7.359)",
    fill: "#866509"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMultimediaFile);
export default __webpack_public_path__ + "static/media/ic_multimedia_file.2c80ea72be6c48a8005d9e672cf36001.svg";
export { ForwardRef as ReactComponent };